import { ModalContext } from '@app/components/shared/Modal/ModalContext';
import { FunctionComponent, useContext } from 'react';
import { ModalOptions } from '../types';

export const useModal = (component: FunctionComponent<any>, props?: any, options?: ModalOptions) => {
  const modalContext = useContext(ModalContext);

  const show = (newProps = null) => {
    modalContext.push(component, newProps || props, options);
  };

  const hide = () => {
    modalContext.pop(component, props, options);
  };

  return { show, hide };
};
